import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg';

function SplitStay(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(G, {
    clipPath: "url(#prefix__clip0_369_122)"
  }, React.createElement(Path, {
    fillRule: "evenodd",
    d: "M11 3a3 3 0 013-3h7a3 3 0 013 3v15a1 1 0 01-1 1h-3a1 1 0 110-2h2V3a1 1 0 00-1-1h-7a1 1 0 00-1 1v1.4a1 1 0 11-2 0V3zM7.419 8.644a1 1 0 011.162 0L12 11.086V17h-1v-2a3 3 0 10-6 0v2H4v-5.899l3.419-2.457zM7 17h2v-2a1 1 0 10-2 0v2zm-5-4.461l-.35.251c-.45.321-1.079.24-1.4-.209-.321-.45-.2-1.16.25-1.481l5.756-4.083a3 3 0 013.488 0l5.837 4.17a1 1 0 11-1.162 1.627l-.419-.3V17h2a1 1 0 110 2h-2v2.055c.24-.034.49-.055.75-.055.975 0 1.921.287 2.705.525l.06.018c.855.259 1.535.457 2.185.457 1.056 0 2.3-.563 2.782-.855a1 1 0 111.036 1.71C22.9 23.23 21.284 24 19.7 24c-.975 0-1.921-.287-2.705-.525l-.06-.018C16.08 23.198 15.401 23 14.75 23c-.598 0-1.1.166-1.831.409l-.124.04c-.781.259-1.73.551-2.995.551-1.248 0-2.326-.285-3.226-.537l-.144-.04C5.56 23.178 4.922 23 4.3 23c-1.056 0-2.3.563-2.782.855-.472.286-1.032.136-1.318-.337-.286-.472-.19-1.087.282-1.373A8.75 8.75 0 012 21.442V19H1c-.552 0-.9-.448-.9-1s.348-1 .9-1h1v-4.461zM12 19v2.605c-.672.218-1.336.395-2.2.395-.952 0-1.8-.215-2.687-.463l-.212-.06C6.109 21.253 5.211 21 4.3 21c-.1 0-.2.003-.3.009V19h8zm5-14h-2v2h2V5zm2 0h2v2h-2V5zm2 4h-2v2h2V9zm-2 4h2v2h-2v-2z",
    clipRule: "evenodd"
  })), React.createElement(Defs, null, React.createElement(ClipPath, {
    id: "prefix__clip0_369_122"
  }, React.createElement(Path, {
    d: "M0 0h24v24H0z"
  }))));
}

export default SplitStay;